import {
    Mufta,
    Filtration,
    Triangle,
    Perforation,
    Bottomhole,
    Paker,
    NKT,
    TwoPakerLayout,
    NKTLeakage,
    ShaftLeakage,
} from './figures';

/*
    TODO: ! нужно отказаться от кириллицы !

    Исследование:
    Каждая фигура здесь имеет свой код или набор кодов.
    Было бы логичнее работать не с названиями фигур, а с их кодами.

    Например, фигура "треугольник" может имеет несколько кодов. Эти коды на сервере могут быть объеденины в одни.
    10: [10, 11, 12, 12]
    Что сделает механизм поиска и отрисовки фигуры проще.
*/

export const PERFORATION_CODE = 'Перфорация';

export const availableFor = {
    firstColumn: ['Перфорация'],
    secondColumn: [
        'Заколонные циркуляции',
        'Негерметичность колонны',
        'Негерметичность забоя',
        'Негерметичность НКТ',
        'Фильтрация',
    ],
    thirdColumn: ['Воронка НКТ', 'Пакер', 'Двухпакерная  компановка', 'Пусковые муфты'],
};

export const excludedTitles = [...new Set([...availableFor.firstColumn, ...availableFor.thirdColumn])];

export const getFlowmetrySymbols = renderData => {
    const { title, researches, minDepth, scale, regimes = [], date, width, toDepth } = renderData;

    switch (title) {
        case 'Перфорация':
            return (
                <>
                    {researches.map((research, index) => {
                        return (
                            <Perforation
                                key={index}
                                research={research}
                                scale={scale}
                                minDepth={minDepth}
                                width={width}
                                title={title}
                                date={date}
                                toDepth={toDepth}
                            />
                        );
                    })}
                </>
            );

        case 'Фильтрация':
            return (
                <>
                    <Filtration
                        researches={researches}
                        minDepth={minDepth}
                        scale={scale}
                        regimes={regimes}
                        date={date}
                        width={width}
                        toDepth={toDepth}
                    />
                </>
            );

        case 'Заколонные циркуляции':
            return (
                <>
                    {researches.map((research, index) => {
                        return (
                            <Triangle
                                key={index}
                                research={research}
                                scale={scale}
                                minDepth={minDepth}
                                width={width}
                                title={title}
                                date={date}
                                toDepth={toDepth}
                            />
                        );
                    })}
                </>
            );

        case 'Негерметичность забоя':
            return (
                <>
                    {researches.map((research, index) => {
                        return (
                            <Bottomhole
                                key={index}
                                scale={scale}
                                minDepth={minDepth}
                                research={research}
                                width={width}
                                title={title}
                                date={date}
                                toDepth={toDepth}
                            />
                        );
                    })}
                </>
            );

        case 'Негерметичность НКТ':
            return (
                <>
                    {researches.map((research, index) => {
                        return (
                            <NKTLeakage
                                key={index}
                                research={research}
                                scale={scale}
                                minDepth={minDepth}
                                width={width}
                                title={title}
                                date={date}
                                toDepth={toDepth}
                            />
                        );
                    })}
                </>
            );

        case 'Негерметичность колонны':
            return (
                <>
                    {researches.map((research, index) => {
                        return (
                            <ShaftLeakage
                                key={index}
                                research={research}
                                scale={scale}
                                minDepth={minDepth}
                                width={width}
                                title={title}
                                date={date}
                                toDepth={toDepth}
                            />
                        );
                    })}
                </>
            );

        case 'Пакер':
            return (
                <>
                    {researches.map((research, index) => {
                        return (
                            <Paker
                                key={index}
                                research={research}
                                scale={scale}
                                minDepth={minDepth}
                                title={title}
                                date={date}
                                width={width}
                                toDepth={toDepth}
                            />
                        );
                    })}
                </>
            );

        case 'Воронка НКТ':
            return (
                <>
                    {researches.map((research, index) => {
                        return (
                            <NKT
                                key={index}
                                research={research}
                                scale={scale}
                                minDepth={minDepth}
                                title={title}
                                date={date}
                                width={width}
                                toDepth={toDepth}
                            />
                        );
                    })}
                </>
            );

        case 'Пусковые муфты':
            return (
                <>
                    {researches.map((research, index) => {
                        const { roof } = research;

                        return (
                            <Mufta
                                key={index}
                                width={width}
                                research={research}
                                title={title}
                                date={date}
                                toDepth={toDepth}
                                style={{
                                    position: 'absolute',
                                    left: 1,
                                    transform: `translateY(${Math.abs((minDepth - roof) * scale - scale + 8)}px)`,
                                }}
                            />
                        );
                    })}
                </>
            );

        case 'Двухпакерная  компановка':
            return (
                <>
                    {researches.map((research, index) => {
                        return (
                            <TwoPakerLayout
                                key={index}
                                research={research}
                                scale={scale}
                                minDepth={minDepth}
                                width={width}
                                title={title}
                                date={date}
                                toDepth={toDepth}
                            />
                        );
                    })}
                </>
            );

        default:
            return (
                <>
                    {researches.map((research, index) => {
                        return (
                            <Triangle
                                key={index}
                                research={research}
                                scale={scale}
                                minDepth={minDepth}
                                width={width}
                                title={title}
                                date={date}
                                toDepth={toDepth}
                            />
                        );
                    })}
                </>
            );
    }
};
